import { Controller } from '@hotwired/stimulus'

// Copy-to-clipboard button for code blocks (T1.8).
//
// Markup contract — placed alongside `code-tabs` on the same `.mkt-code`:
//   <div class="mkt-code" data-controller="code-tabs copy-button">
//     <button data-copy-button-target="button"
//             data-action="click->copy-button#copy">
//       <span data-copy-button-target="label">Copy</span>
//     </button>
//     ...
//     <div class="mkt-code__panel" data-active="true">...</div>
//   </div>
//
// Copies the text of whichever panel is currently `data-active="true"`.
export default class extends Controller {
  static targets = ['button', 'label']

  copy() {
    const panel = this.element.querySelector('.mkt-code__panel[data-active="true"]')
    if (!panel) return
    const text = panel.innerText || panel.textContent || ''
    if (!text) return

    const writer = (navigator.clipboard && navigator.clipboard.writeText)
      ? navigator.clipboard.writeText(text)
      : this._fallback(text)

    Promise.resolve(writer)
      .then(() => this._flash('Copied'))
      .catch(() => this._flash('Press Cmd+C'))
  }

  _flash(text) {
    if (!this.hasButtonTarget) return
    const btn = this.buttonTarget
    btn.classList.add('is-copied')
    let original = 'Copy'
    if (this.hasLabelTarget) {
      original = this.labelTarget.textContent
      this.labelTarget.textContent = text
    }
    clearTimeout(this._t)
    this._t = setTimeout(() => {
      btn.classList.remove('is-copied')
      if (this.hasLabelTarget) this.labelTarget.textContent = original
    }, 1500)
  }

  _fallback(text) {
    return new Promise((resolve, reject) => {
      try {
        const ta = document.createElement('textarea')
        ta.value = text
        ta.setAttribute('readonly', '')
        ta.style.position = 'fixed'
        ta.style.top = '-9999px'
        document.body.appendChild(ta)
        ta.select()
        const ok = document.execCommand('copy')
        document.body.removeChild(ta)
        ok ? resolve() : reject(new Error('execCommand failed'))
      } catch (e) {
        reject(e)
      }
    })
  }
}
